import { Link } from "react-router-dom";

import type { EventNotice } from "../../../api/types";
import { Card, EmptyState } from "../../../ui";
import { plainNotice } from "../../../ui/words";
import { useNow } from "../hooks";
import { noticeTarget } from "../model/people";
import { formatWhen } from "../model/time";
import { navigatorHref } from "../model/words";

/** The latest changes of the discipline, newest first. New ones pop in as the live channel brings them. */
export function LiveFeed({ notices, arrivals }: { notices: readonly EventNotice[]; arrivals?: ReadonlySet<string> }) {
  const now = useNow();
  return (
    <Card aria-labelledby="feed-title" className="nv-feed">
      <h2 id="feed-title">What is happening</h2>
      {notices.length === 0 ? (
        <EmptyState title="Nothing has happened yet">Changes appear here as your colleagues work.</EmptyState>
      ) : (
        <ul className="nv-feed__list">
          {notices.map((notice) => {
            const target = noticeTarget(notice);
            return (
              <li key={notice.number} className={arrivals?.has(String(notice.number)) ? "nv-feed__item nv-feed__item--new" : "nv-feed__item"}>
                <span>{plainNotice(notice.summary)}</span> <span className="muted">{formatWhen(notice.at, now)}</span>
                {target && (
                  <>
                    {" "}
                    <Link to={navigatorHref(target)}>Show in the tree</Link>
                  </>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </Card>
  );
}
